<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش جزئیات کلاس گروهی"
    :dialogId="`update-group-class-link-by-master-dialog-${dialogId}`"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateGroupClassLinkRequest"
  >
    <BCol cols="12">
      <TextInput
        inputId="masterGroupClassTitle"
        inputLabel="عنوان کلاس"
        inputPlaceholder="آیلتس تخصصی"
        v-model="updateGroupClassLinkPayload.masterTitle"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <BAlert class="p-1" show variant="warning">
        <FeatherIcon icon="InfoIcon" size="23"></FeatherIcon>
        <span class="custom-margin">
          لطفا لینک خود را با https و بدون متن اضافی وارد کنید
        </span>
      </BAlert>
    </BCol>
    <BCol cols="12">
      <TextInput
        inputId="classLink"
        inputLabel="لینک کلاس"
        inputPlaceholder="https://meet.google.com/XAS-sgfta-214"
        v-model="computedGroupClassLink"
        :errorMessage="
          isRenderingLinkError
            ? 'لطفا لینک خود را با فرمت https://example.com/anything وارد کنید'
            : null
        "
      ></TextInput>
    </BCol>

    <template v-if="selectedGroupClass.studentsCount == 0">
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassDate"
          @getSelectedDate="setGroupClassDate"
          inputLabel="تاریخ کلاس"
          :value="updateGroupClassLinkPayload.startDate"
          inputPlaceholder="1403/06/05"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassStartTime"
          :readonly="!selectedClassDate"
          :roundMinute="false"
          :value="updateGroupClassLinkPayload.startDate"
          @getSelectedDate="setGroupClassStartTime"
          inputLabel="ساعت شروع کلاس"
          inputPlaceholder="12:30"
          type="time"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassEndTime"
          :readonly="!updateGroupClassLinkPayload.startDate"
          :roundMinute="false"
          :value="updateGroupClassLinkPayload.endDate"
          :jumpMinute="selectedGroupClass.duration"
          :min="updateGroupClassLinkPayload.startDate"
          @getSelectedDate="setGroupClassEndTime"
          inputLabel="ساعت پایان کلاس"
          inputPlaceholder="14:30"
          type="time"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomDatePicker
          inputId="groupClassDeadline"
          @getSelectedDate="setGroupClassDeadline"
          :value="updateGroupClassLinkPayload.deadLine"
          inputLabel="مهلت ثبت نام شاگرد ها"
          inputPlaceholder="1403/06/05"
          type="datetime"
        ></CustomDatePicker>
      </BCol>
    </template>

    <BCol cols="12">
      <CustomTextarea
        rows="3"
        inputId="masterGroupClassDescription"
        inputLabel="توضیحات استاد (دلخواه)"
        inputPlaceholder="توضیحات..."
        :maxChars="2000"
        customRules="max:2000"
        :charsCount="
          updateGroupClassLinkPayload.masterDescription
            ? updateGroupClassLinkPayload.masterDescription.length
            : 0
        "
        v-model="updateGroupClassLinkPayload.masterDescription"
      ></CustomTextarea>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedGroupClass: {
      type: Object,
    },
    dialogId: {
      type: [String, Number],
    },
  },
  watch: {
    selectedGroupClass: {
      handler(val) {
        if (val) {
          this.setGroupClassDate(val.startDate);
          this.setGroupClassStartTime(val.startDate);
          this.setGroupClassEndTime(val.endDate);
          this.setGroupClassDeadline(val.deadLine);
          this.updateGroupClassLinkPayload.groupClassMasterId = val.id;
          this.updateGroupClassLinkPayload.link = val.groupClassLink
            ? val.groupClassLink
            : "";
          this.updateGroupClassLinkPayload.masterTitle = val.masterTitle
            ? val.masterTitle
            : "";
          this.updateGroupClassLinkPayload.masterDescription =
            val.masterDescription ? val.masterDescription : "";
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      isRenderingLinkError: false,
      urlRegex: /(https?:\/\/[^\s]+)/g,
      updateGroupClassLinkPayload: {
        groupClassMasterId: null,
        link: null,
        masterTitle: null,
        masterDescription: null,
        startDate: null,
        endDate: null,
        deadLine: null,
      },
      selectedClassDate: null,
    };
  },
  methods: {
    setGroupClassDate(selectedDate) {
      if (selectedDate) {
        this.selectedClassDate = new Date(selectedDate).toISOString();
        this.selectedClassDate = new Date(selectedDate).toISOString();
        this.setGroupClassStartTime(this.updateGroupClassLinkPayload.startDate);
        this.setGroupClassEndTime(this.updateGroupClassLinkPayload.endDate);
      } else {
        this.selectedClassDate = null;
        this.selectedClassDate = null;
        this.updateGroupClassLinkPayload.startDate = null;
        this.updateGroupClassLinkPayload.endDate = null;
        this.updateGroupClassLinkPayload.deadLine = null;
      }
    },
    setGroupClassStartTime(startTime) {
      this.updateGroupClassLinkPayload.startDate = this.customSetHourOnDate(
        this.selectedClassDate,
        startTime
      )?.toISOString();
    },
    setGroupClassEndTime(endTime) {
      this.updateGroupClassLinkPayload.endDate = this.customSetHourOnDate(
        this.selectedClassDate,
        endTime
      )?.toISOString();
    },
    setGroupClassDeadline(deadLine) {
      if (deadLine) {
        this.updateGroupClassLinkPayload.deadLine = new Date(
          deadLine
        ).toISOString();
      }
    },
    async sendUpdateGroupClassLinkRequest() {
      try {
        this.isOkButtonDisabled = true;
        const _this = this;
        const updateGroupClassLink = new UpdateGroupClassLink(_this);
        updateGroupClassLink.setRequestParamDataObj(
          _this.updateGroupClassLinkPayload
        );
        await updateGroupClassLink.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "لینک کلاس گروهی با موفقیت ویرایش شد.",
              },
            });
            _this.updateGroupClassLinkPayload = {
              groupClassMasterId: null,
              link: null,
            };
            _this.$emit("refetch");
            _this.$bvModal.hide(
              `update-group-class-link-by-master-dialog-${this.dialogId}`
            );
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    computedGroupClassLink: {
      get() {
        return this.updateGroupClassLinkPayload.link;
      },
      set(value) {
        if (value) {
          const splitedUrl = value.match(this.urlRegex);
          if (splitedUrl && splitedUrl[0]) {
            this.updateGroupClassLinkPayload.link = splitedUrl[0];
            this.isRenderingLinkError = false;
          } else {
            this.isRenderingLinkError = true;
            this.updateGroupClassLinkPayload.link = "";
          }
        } else {
          this.updateGroupClassLinkPayload.link = value;
          this.isRenderingLinkError = false;
        }
      },
    },
  },
  mixins: [timeConvertUtils],
  components: {
    CustomUpdateDialog,
    CustomTextarea,
    CustomDatePicker,
    TextInput,
    BCol,
    BAlert,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import CustomTextarea from "@/views/components/Utils/CustomTextarea.vue";
import { BCol, BAlert } from "bootstrap-vue";
import { UpdateGroupClassLink } from "@/libs/Api/GroupClass";
</script>

<style scoped>
.custom-margin {
  margin-left: 6px;
}
</style>
